import { useEffect, useState } from "react";
import "./HeaderBackground.css";

const images = [
    "https://ik.imagekit.io/kimchel/Sevasti-title/homeImage1.jpg",
    "https://ik.imagekit.io/kimchel/Sevasti-title/homeImage3.jpg",
    "https://ik.imagekit.io/kimchel/Sevasti-title/homeImage4.jpg",
];

export const HeaderBackground = () => {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            const next = getNextImageIndex(current);
            setCurrent(next);
        }, 6500);
        return () => clearInterval(interval);
    }, [current]);

    const getNextImageIndex = (currentIndex: number) => {
        let nextIndex = Math.floor(Math.random() * images.length);
        while (nextIndex === currentIndex) {
            nextIndex = Math.floor(Math.random() * images.length);
        }
        return nextIndex;
    };

    return (
        <div className="headerContainer">
            {images.map((image, index) => (
                <div
                    key={index}
                    className={`backgroundImage ${index === current ? "fadeIn" : "fadeOut"}`}
                    style={{ backgroundImage: `url(${image})` }}
                />
            ))}
        </div>
    );
}